import { render, staticRenderFns } from "./SucTextFormShowField.vue?vue&type=template&id=eb4a56c0&"
import script from "./SucTextFormShowField.vue?vue&type=script&lang=js&"
export * from "./SucTextFormShowField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports